/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- REVENUE REPORT CHART : STYLES --------------- ++++++++++ */
export default {
	revenuereportchart: {
        minWidth: '500px',
        // overflowX: 'auto',
        // overflowY: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
		marginTop: pxToEm(16),
		height: pxToEm(241),
        width: '100%',
		'& > div': {
			height: `${pxToEm(241)} !important`
		},
        '&::-webkit-scrollbar': {
            height: pxToEm(6)
        },
        '&::-webkit-scrollbar-thumb': {
            background: 'rgba(6, 43, 117, 0.2)',
            borderRadius: pxToEm(3)
        },
        '& text': {
            fontSize: `${pxToEm(11)} !important`
        }
	}
};
